import { render, staticRenderFns } from "./PreviewPgt.vue?vue&type=template&id=a2bc8c24"
import script from "./PreviewPgt.vue?vue&type=script&lang=ts"
export * from "./PreviewPgt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports